import React, { memo, useEffect, useState } from 'react'

import { Select, SelectItem } from '@ublique/components/Select'
import MatrixUX from '@ublique/components/MatrixUX'

import { isInvalidByField } from '../utils/form'
import { MONTHDAYS, WEEKDAYS, days } from '../constants'
import { getWeekdays /*, getWeekNumbers */ } from '../utils/options'
import InfoButton from './InfoButton'
import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'

const JobDays = ({
  t,
  disabled,
  weekdays,
  monthdays,
  editingValues,
  setFieldValue
}) => {
  const [dayType, setDayType] = useState(
    isEmpty(weekdays) ? MONTHDAYS : WEEKDAYS
  )
  const [isDaily, setIsDaily] = useState(
    dayType === MONTHDAYS ? isEmpty(monthdays) : isEmpty(weekdays)
  )
  const weekdaysData = getWeekdays(t)

  // const [weekNumber, setWeekNumber] = useState('')
  // TODO: Move this state to the parent when the feature is available - Leaving this as a reference
  // Let useCronExp handle the logic for the number of the week
  // const weekNumbers = getWeekNumbers(t)

  // Cleanup values
  useEffect(() => {
    if (isDaily) {
      setFieldValue(MONTHDAYS, [])
      setFieldValue(WEEKDAYS, [])
    }
  }, [isDaily])

  useEffect(() => {
    if (dayType === MONTHDAYS) {
      setFieldValue(WEEKDAYS, [])
    }
    if (dayType === WEEKDAYS) {
      setFieldValue(MONTHDAYS, [])
    }
  }, [dayType])

  return (
    <>
      <Select
        labelText={t('Crontab.DAYS')}
        disabled={disabled}
        value={dayType}
        onChange={(event) => setDayType(event.target.value)}
        children={[
          <SelectItem
            key={MONTHDAYS}
            text={t('Crontab.MONTHDAYS')}
            value={MONTHDAYS}
          />,
          <SelectItem
            key={WEEKDAYS}
            text={t('Crontab.WEEKDAYS')}
            value={WEEKDAYS}
          />
        ]}
      />
      {dayType === MONTHDAYS && (
        <MatrixUX
          disabled={disabled || isDaily}
          id='monthdays'
          labelText={t('Crontab.MONTHDAYS')}
          labelTooltip={
            <InfoButton message={t('Crontab.Fields.MONTHDAYS_TOOLTIP')} />
          }
          data={days}
          columns={7}
          multiple
          selected={
            Array.isArray(monthdays)
              ? monthdays
              : !isUndefined(monthdays)
              ? [monthdays]
              : []
          }
          setSelected={(value) => setFieldValue(MONTHDAYS, value)}
          invalid={isInvalidByField.monthdays({
            value: monthdays,
            disabled,
            isEditing: editingValues[MONTHDAYS]
          })}
          invalidText={t('Crontab.MONTHDAYS_INVALID')}
          canSelectAll
          selectAll={isDaily}
          onSelectAllChange={setIsDaily}
          selectAllTooltip={t('Crontab.DAILY')}
        />
      )}
      {dayType === WEEKDAYS && (
        <>
          {/* <Select
            disabled
            labelText={t('Crontab.WEEK')}
            value={weekNumber}
            onChange={setWeekNumber}
            children={weekNumbers.map(({ label, value }) => (
              <SelectItem key={value} text={label} value={value} />
            ))}
          /> */}
          <MatrixUX
            disabled={disabled || isDaily}
            id='weekdays'
            labelText={t('Crontab.WEEKDAYS')}
            labelTooltip={
              <InfoButton message={t('Crontab.Fields.WEEKDAYS_TOOLTIP')} />
            }
            data={weekdaysData}
            multiple
            selected={
              Array.isArray(weekdays)
                ? weekdays
                : !isUndefined(weekdays)
                ? [weekdays]
                : []
            }
            setSelected={(value) => setFieldValue(WEEKDAYS, value)}
            invalid={isInvalidByField.weekdays({
              value: weekdays,
              disabled,
              isEditing: editingValues[WEEKDAYS]
            })}
            invalidText={t('Crontab.WEEKDAYS_INVALID')}
            canSelectAll
            selectAll={isDaily}
            onSelectAllChange={setIsDaily}
            selectAllTooltip={t('Crontab.DAILY')}
            columns={7}
          />
        </>
      )}
    </>
  )
}

export default memo(JobDays)
